import {IFilterFunction} from "angular";
import {ContractNoteStatus, contractNoteStatusName} from "../../types/ContractNoteRecord";

export const ContractNoteStatusPipe = "tfCNoteStatus";

export function contractNoteStatusPipe(): IFilterFunction {
    return (status: ContractNoteStatus | null) => {
        if (status == null) {
            return null;
        } else {
            return contractNoteStatusName(status);
        }
    };
}
